import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const paymentInfo = async (params: object) => {
  return await GET({ url: Api.paymentInfo, params, showError: false })
}
export const toPay = async (params: object) => {
  return await POST({ url: Api.toPay, params, showError: false })
}
